import { useMutation } from "react-query";
import axios from "../axios";

const useOtpVerify = ({ onSuccess, onError }) => {
  const mutation = useMutation(
    async (params) => {
      return await axios.post("/api/auth/otp/verify", {
        email: params.email,
        otp: params.otp,
      });
    },
    {
      onSuccess: (res) => onSuccess(res),
      onError: (err) => onError(err),
    }
  );

  return mutation;
};

export default useOtpVerify;
